module.exports = __webpack_public_path__ + "852d69b0367bbaab1bc28c7afe514126.png";